var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"home-container"},[_c('el-header',[_c('div',[_c('span',[_vm._v("MES运营平台")])]),_c('home-header')],1),_c('el-container',[_c('home-left'),_c('home-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }